import React from 'react'

const MultiMedicals = ({
	size = 24,
	color = '#129878',
	fillColor,
	strokeColor,
	...props
}) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M15.6 6H4.4C3.76348 6 3.15303 6.25286 2.70294 6.70294C2.25286 7.15303 2 7.76348 2 8.4V19.6C2 20.2365 2.25286 20.847 2.70294 21.2971C3.15303 21.7471 3.76348 22 4.4 22H15.6C16.2365 22 16.847 21.7471 17.2971 21.2971C17.7471 20.847 18 20.2365 18 19.6V8.4C18 7.76348 17.7471 7.15303 17.2971 6.70294C16.847 6.25286 16.2365 6 15.6 6ZM16.4 19.6C16.4 19.8122 16.3157 20.0157 16.1657 20.1657C16.0157 20.3157 15.8122 20.4 15.6 20.4H4.4C4.18783 20.4 3.98434 20.3157 3.83431 20.1657C3.68429 20.0157 3.6 19.8122 3.6 19.6V8.4C3.6 8.18783 3.68429 7.98434 3.83431 7.83431C3.98434 7.68429 4.18783 7.6 4.4 7.6H15.6C15.8122 7.6 16.0157 7.68429 16.1657 7.83431C16.3157 7.98434 16.4 8.18783 16.4 8.4V19.6ZM14 11.6H12.4V10C12.4 9.78783 12.3157 9.58434 12.1657 9.43431C12.0157 9.28429 11.8122 9.2 11.6 9.2H8.4C8.18783 9.2 7.98434 9.28429 7.83431 9.43431C7.68429 9.58434 7.6 9.78783 7.6 10V11.6H6C5.78783 11.6 5.58434 11.6843 5.43431 11.8343C5.28429 11.9843 5.2 12.1878 5.2 12.4V15.6C5.2 15.8122 5.28429 16.0157 5.43431 16.1657C5.58434 16.3157 5.78783 16.4 6 16.4H7.6V18C7.6 18.2122 7.68429 18.4157 7.83431 18.5657C7.98434 18.7157 8.18783 18.8 8.4 18.8H11.6C11.8122 18.8 12.0157 18.7157 12.1657 18.5657C12.3157 18.4157 12.4 18.2122 12.4 18V16.4H14C14.2122 16.4 14.4157 16.3157 14.5657 16.1657C14.7157 16.0157 14.8 15.8122 14.8 15.6V12.4C14.8 12.1878 14.7157 11.9843 14.5657 11.8343C14.4157 11.6843 14.2122 11.6 14 11.6ZM13.2 14.8H11.6C11.3878 14.8 11.1843 14.8843 11.0343 15.0343C10.8843 15.1843 10.8 15.3878 10.8 15.6V17.2H9.2V15.6C9.2 15.3878 9.11571 15.1843 8.96569 15.0343C8.81566 14.8843 8.61217 14.8 8.4 14.8H6.8V13.2H8.4C8.61217 13.2 8.81566 13.1157 8.96569 12.9657C9.11571 12.8157 9.2 12.6122 9.2 12.4V10.8H10.8V12.4C10.8 12.6122 10.8843 12.8157 11.0343 12.9657C11.1843 13.1157 11.3878 13.2 11.6 13.2H13.2V14.8Z"
			fill={fillColor || color}
		/>
		<path
			d="M7.5 3H16C18.7614 3 21 5.23858 21 8V18"
			stroke={strokeColor || color}
			strokeWidth="1.7"
			strokeLinecap="round"
		/>
	</svg>
)

export default MultiMedicals